import { get, isEqual } from 'lodash';
import * as React from 'react';
import { connect } from 'react-redux';
import { goToAnchor, removeHash } from 'react-scrollable-anchor';
import { Progress } from 'reactstrap';
import { bindActionCreators } from 'redux';
import { HFTModule } from '../../redux/modules/hft/entry';
import './Home.css';
import { JoinClub } from './JoinClub';
import { Navbar } from './Navbar';
import { PriceTable } from './PriceTable';
import { ProductButtons } from './ProductButtons';
import { ProductList } from './ProductList';
import { PromotionBlock } from './PromotionBlock';
import { TermsAndConditions } from './TermsAndConditions';

// configureAnchors({
//   keepLastAnchorHash: true
// });

interface IHomeProps {
  config: any;
  status: any;
  fetchConfig: () => void;
};

class Home extends React.Component<IHomeProps, undefined> {

  public componentDidMount() {
    const hash = location.hash.slice(1);
    this.props.fetchConfig();
    removeHash();
    window.setTimeout(() => goToAnchor(hash), 1000);
  }

  public componentWillReceiveProps(nextProps: IHomeProps) {

    const { config } = nextProps;

    if (
      !isEqual(
        get(this.props, 'status.config'),
        get(nextProps, 'status.config')
      )
      &&
      get(nextProps, 'status.config') === 'success'
    ) {
      document.title = config.name;
      document.body.style.background = `url('${config.image_path}${config.background.image}') no-repeat top center fixed`;
      document.body.style.backgroundSize = 'cover';
    }
  }

  public render() {

    const { lang } = HFTModule;
    const { config } = this.props;

    if (!get(this.props, 'status.config') || get(this.props, 'status.config') === 'request') {
      return (
        <Progress color='success' animated={true} value={100} style={{ margin: '45vh 16px' }}>
          {lang.loading}
        </Progress>
      );
    }

    return (
      <div className='App'>
        <Navbar
          image_path={config.image_path}
          name={config.brand.name}
          url={config.brand.url}
          logo={config.brand.logo}
          boxes={config.brand.boxes}
          banner={config.brand.banner}
          deliveryeform={config.brand.deliveryeform}
          banner_header={config.brand.banner_header}
          colors={config.colors}
        />
        <PromotionBlock
          image_path={config.image_path}
          promotion={config.promotion}
          colors={config.colors}
        />
        <PriceTable
          image_path={config.image_path}
          image={config.price_table.image}
          title={config.price_table.title}
          url={config.price_table.url}
        />
        <ProductButtons
          image_path={config.image_path}
          product_list={config.product_list}
          colors={config.colors}
        />
        <ProductList
          image_path={config.image_path}
          product_list={config.product_list}
          colors={config.colors}
        />
        <TermsAndConditions
          colors={config.colors}
          image_path={config.image_path}
          data={config.terms_and_conditions}
        />
        <JoinClub
          image_path={config.image_path}
          data={config.join_club}
        />
      </div>
    );
  }
}

export default connect<{}, {}, IHomeProps>(
  (state: any) => ({
    config: HFTModule.selectors.config(state),
    status: HFTModule.selectors.status(state),
  }),
  (dispatch: any) => bindActionCreators({
    fetchConfig: HFTModule.actions.creators.fetchConfig.request,
  }, dispatch),
)(Home as any);



// WEBPACK FOOTER //
// ./src/pages/Home/index.tsx